<template>
  <div>
    <el-dialog :visible.sync="visible" :before-close="closeVisible" :close-on-click-modal="false" title="选择区域"
      width="1200px">
      <div>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="area in checkList" :key="area" :label="area">{{area}}区域</el-checkbox>
          <!-- <el-checkbox label="A">A区域</el-checkbox>
          <el-checkbox label="B">B区域</el-checkbox>
          <el-checkbox label="C">C区域</el-checkbox>
          <el-checkbox v-if="!propData.city" label="D">D区域</el-checkbox>
          <el-checkbox label="Z">Z区域</el-checkbox> -->
        </el-checkbox-group>
      </div>
      <div class="infoText">
        <p v-if="checkList.indexOf('A')>-1"><span
            class="colorFont">A区域：</span>{{propData.countAall}}卡位，空置卡位数：{{propData.countA}}，空置率{{(propData.countA / propData.countAall * 100).toFixed(2) }}%
        </p>
        <p v-if="checkList.indexOf('B')>-1"><span
            class="colorFont">B区域：</span>{{propData.countBall}}卡位，空置卡位数：{{propData.countB}}，空置率{{(propData.countB / propData.countBall * 100).toFixed(2) }}%
        </p>
        <p v-if="checkList.indexOf('C')>-1"><span
            class="colorFont">C区域：</span>{{propData.countCall}}卡位，空置卡位数：{{propData.countC}}，空置率{{(propData.countC / propData.countCall * 100).toFixed(2) }}%
        </p>
        <p v-if="checkList.indexOf('D')>-1"><span
            class="colorFont">D区域：</span>{{propData.countDall}}卡位，空置卡位数：{{propData.countD}}，空置率{{(propData.countD / propData.countDall * 100).toFixed(2) }}%
        </p>
        <p v-if="checkList.indexOf('Z')>-1"><span
            class="colorFont">Z区域：</span>{{propData.countZall}}卡位，空置卡位数：{{propData.countZ}}，空置率{{ propData.countZ?(propData.countZ / propData.countZall * 100).toFixed(2): 0}}%
        </p>
        <p ><span
            class="colorFont">全区域：</span>{{propData.all}}卡位，空置卡位数：{{propData.allKong}}，空置率{{((propData.allKong/propData.all * 100).toFixed(2))}}%
        </p>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeVisible">取 消</el-button>
        <el-button size="small" type="primary" @click="submit">确定</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    propData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    visible(val) {
      // if (val && this.propData.city) {
      //   this.checkLists = ['A', 'B', 'C', 'Z']
      // } else {
      //   this.checkLists = ['A', 'B', 'C', 'D', 'Z']
      // }
      if (val) {
        this.checkList = this.checkListAll[this.propData.city]
      }
    },
    checkList(val) {
      this.checkList = val
    }

  },
  data() {
    return {
      checkListAll: {
        0: ['A', 'B', 'C', 'D', 'Z'],
        1: ['A', 'B', 'C', 'Z'],
        2: ['A', 'B'],
        3: ['A', 'B', 'C'],
        4: ['A', 'B', 'C', 'Z'] // 39楼区域：A、B、C、Z
      },
      checkList: ['A', 'B', 'C', 'D', 'Z'],
      checkAll: true,
      isIndeterminate: false
    }
  },
  methods: {
    closeVisible() {
      this.$emit('close', false)
    },
    handleCheckAllChange(val) {
      this.checkList = val ? this.checkListAll[this.propData.city] : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === 5
      this.isIndeterminate = checkedCount > 0 && checkedCount < 5
    },
    submit() {
      this.$emit('updateCheck', this.checkList)
      this.closeVisible()
    }

  }
}
</script>

<style scoped>
  .infoText {
    /* padding-left: 2rem; */
  }

  .colorFont {
    color: #41a1ff;
    font-weight: bold;
  }
</style>
